import {
    Wrapper,
    WrapperFirstRow,
    Line,
    FirstRowBox,
    SecondRowBox,
    ThirdRowBox,
    FourthRowBox,
    RowFlex1,
    RowFlex2,
    FourthRowBoxItem
} from './style'
import React  from 'react';
import { Box, Flex } from 'reflexbox'
import FooterLogo from '../../image/FooterLogo.png'

export const Footer = () => {
    return (
        <Wrapper>
            <WrapperFirstRow>
                <RowFlex1>
                    <FirstRowBox>
                        <img src={FooterLogo} alt="footer logo" />
                    </FirstRowBox>
                    <SecondRowBox>
                        Plaza Bank Index 9th Floor, 
                        Suite 09-24A, Jl. M.H. Thamrin No.Kav. 57,
                        Gondangdia, Kec. Menteng, Jakarta 10350
                    </SecondRowBox>
                </RowFlex1>
                <RowFlex2>
                    <ThirdRowBox>
                        <div>(+6221) 3903339</div>
                        <Box marginTop="20px">info@sequoiaadvocates.com</Box>
                    </ThirdRowBox>
                    <FourthRowBox>
                        <FourthRowBoxItem>PRACTICE AREA</FourthRowBoxItem>
                        <FourthRowBoxItem>MEET OUR EXPERTS</FourthRowBoxItem>
                        <FourthRowBoxItem>ARTICLE & NEWS</FourthRowBoxItem>
                    </FourthRowBox>
                </RowFlex2>
            </WrapperFirstRow>
            <div>
                <Line />
            </div>
            <Flex alignItems="center" justifyContent="center" textAlign="center">
                &copy; 2024 - Sequoia Advocates is Your Trusted Legal Resource
            </Flex>
        </Wrapper>
    )
}